<div
	class="accRow"
	(click)="bExpanded = !bExpanded"
	[class.accRowActive]="bExpanded"
>
	<div class="accCell">
		{{title}}
	</div>
</div>

@if( bExpanded ) {

	<div class="accDetail" [@accordeonMe] [formGroup]="legalFormGroup">

		<ngx-editor-menu
			[editor]="editor"
			[toolbar]="toolbar"
		/>

		<ngx-editor
			[editor]="editor"
			[placeholder]="placeholder || title"
			formControlName="legalContent"
		/>
	</div>

	<div class="autoSaveIndicator">
		@if( bSaving ) {
			<span>Automatisches Speichern läuft</span>
			<mat-spinner diameter=20 />
		}
		@else if( tmsLastSave !== null ) {
			<span>Automatisch gespeichert</span>
			<span class="material-icons">check</span>
		}
	</div>
	@if( bSavingError ) {
		<div class="errorWarning">
			Beim Speichern der Daten ist ein Fehler aufgetreten
		</div>
	}

}